import PixelModal from './PixelModal';

export default PixelModal;
